import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import size from 'lodash/size';
import qs from 'query-string';

import { detectMobileDevice } from '../../../util/detectBrowser';

import { fetchWedding } from '../../../actions/WeddingActions';
import { getPartnerAccount } from '../../../actions/AccountInvitationActions';
import * as checklistV2Actions from '../../../actions/ChecklistV2Actions';
import * as checklistSelectors from '../../../selectors/checklist/checklistSelectors';

import ChecklistV2Container from './ChecklistV2Container';

export const mapStateToProps = (state, ownProps) => ({
  loading: checklistSelectors.getChecklistLoading(state),
  selectedTaskId: get(ownProps, 'params.id'),
  noFilterResults: checklistSelectors.getNoFilterResults(state),
});

export const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => {
    const { location } = ownProps;
    const isMobile = detectMobileDevice();
    let { q: filters } = qs.parse(location.search);

    dispatch(fetchWedding());
    dispatch(getPartnerAccount());

    if (size(filters)) {
      filters = filters.split(',');
      dispatch(checklistV2Actions.replaceTaskFilters(filters));

      return dispatch(checklistV2Actions.filterTasks()).then(() => {
        if (!isMobile) dispatch(checklistV2Actions.setFirstFilteredTaskActive());
      });
    }

    return dispatch(checklistV2Actions.fetchChecklist()).then(() => {
      const isOnTask = Boolean(get(ownProps, 'params.id'));
      const selectedTaskId = Number(get(ownProps, 'params.id')) || null;

      if (!isMobile && !isOnTask) dispatch(checklistV2Actions.setFirstTaskAsActive());
      if (isOnTask) dispatch(checklistV2Actions.selectTask(selectedTaskId));
    });
  },
  filterTasks: () => dispatch(checklistV2Actions.filterAndSyncFiltersInURL()),
  clearFilters: () => dispatch(checklistV2Actions.clearFiltersAndResetURL()),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ChecklistV2Container),
);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/index.js